import Model from "src/models/base/model.js";

class QuotationNfe extends Model{
  resourceName() {
    return "quotation_nfes";
  }

  fields() {
    return {
      key: "",
      number: "",
      name: "",
      path: "",
      cte_id: "",
      value: "",
    }
  }
}

export default new QuotationNfe();
